import { Action } from '@/_core/fluxstore/types';
import { StorymapState, defaultFilters } from '../../types';
import { useStorymapStore } from '../../useModule';
import cloneDeep from 'lodash/cloneDeep';

const { registerReducer } = useStorymapStore();

export class ClearFilters extends Action<StorymapState> {
    public static ACTION_TYPE = 'ClearFilters';

    public constructor() {
        super(ClearFilters.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState): void => {
    state.filterState = cloneDeep(defaultFilters);
};

//@ts-ignore
registerReducer(ClearFilters.ACTION_TYPE, reducer);
